import api from '../../utils/api';
import { getApiUrl } from '../../utils/config';

export const getPublicAboutSections = (slug) =>
  api.get(getApiUrl(`/stores/${slug}/about`));

export const getAdminAboutSections = (storeId) =>
  api.get(getApiUrl(`/stores-admin/${storeId}/about`));

export const createAboutSection = (storeId, data) =>
  api.post(getApiUrl(`/stores-create/${storeId}/about`), data);

export const updateAboutSection = (id, data) =>
  api.put(getApiUrl(`/about-sections/${id}`), data);

export const deleteAboutSection = (id) =>
  api.delete(getApiUrl(`/about-sections/${id}`)); 